import React from 'react';
import { useRecoilState } from 'recoil'
import { collapsedState } from '../../utils/recoil-atoms'
import {Link} from 'gatsby'
import logo from "../../assets/images/amamlogo.png"

import { useAuth0 } from '@auth0/auth0-react';

const Navbar = () => {
    const { isAuthenticated, user, loginWithRedirect, logout } = useAuth0();    

    const [collapsed, setCollapsed] = useRecoilState(collapsedState);

    const toggleNavbar = () => {
        setCollapsed(!collapsed);
    }

    React.useEffect(() => {
        let elementId = document.getElementById("navbar");
        document.addEventListener("scroll", () => {
            if (window.scrollY > 170) {
                elementId.classList.add("is-sticky");
            } else {
                elementId.classList.remove("is-sticky");
            }
        });
        window.scrollTo(0, 0);
    })

    const classOne = collapsed ? 'collapse navbar-collapse' : 'collapse navbar-collapse show';
    const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';

    return (
        <React.Fragment>
            <div id="navbar" className="navbar-area">
                <div className="tarn-nav">
                    <div className="container-fluid">
                        <nav className="navbar navbar-expand-lg navbar-light">
                            <Link 
                                to="/"
                                onClick={() => setCollapsed(true)} 
                                className="navbar-brand"
                            >
                                <img src={logo} alt="logo" />
                            </Link>

                            <button
                                onClick={toggleNavbar} 
                                className={classTwo}
                                type="button" 
                                data-toggle="collapse" 
                                data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" 
                                aria-expanded="false" 
                                aria-label="Toggle navigation"
                            >
                                <span className="icon-bar top-bar"></span>
                                <span className="icon-bar middle-bar"></span>
                                <span className="icon-bar bottom-bar"></span>
                            </button>

                            <div className={classOne} id="navbarSupportedContent">
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <Link
                                            to="/"
                                            activeClassName="active"
                                            onClick={() => setCollapsed(true)}
                                            className="nav-link"
                                        >
                                            Inicio
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            to="/newsletters"
                                            activeClassName="active"
                                            onClick={() => setCollapsed(true)}
                                            className="nav-link"
                                        >
                                            Newsletters
                                        </Link>
                                    </li>
                                </ul>
                            
                                <div className="others-option d-flex align-items-center">
                                    <div className="option-item">   

                                        {isAuthenticated ? (
                                            <div>
                                            <span id="hello">Hola, <span style={{'text-decoration': 'underline'}}>{user.name}</span></span>{' '}
                                            <button
                                                className="default-btn small" style={{'border-radius': '10px'}}
                                                id="logout"
                                                onClick={() => logout({ returnTo: window.location.origin })}
                                            >
                                                <i className="flaticon-open-padlock"></i>
                                                Salir
                                            </button>
                                            </div>
                                        ) : (
                                            <a 
                                                href=""
                                                activeClassName="active"
                                                id="login" onClick={(e) => {loginWithRedirect(); e.preventDefault()}}
                                                className="default-btn">
                                                <i className="flaticon-right"></i> Iniciar sesión <span></span>
                                            </a>
                                        )}                                        
                                                                      
                                    </div>
                                </div>

                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Navbar;
